import { Component, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SearchFlightControllerService } from '@booking/angular-booking-flight-search-service';
import { catchError, finalize, of, retry, Subscription } from 'rxjs';
import moment from 'moment';

@Component({
  selector: 'app-suggested-for-you',
  templateUrl: './suggested-for-you.component.html',
  styleUrls: ['./suggested-for-you.component.scss'],
})
export class SuggestedForYouComponent {
  // @Input() code: string;
  @Input() numOfAdults: number = 1;
  @Input() numOfChildren: number = 0;
  @Input() numOfInfants: number = 0;
  @Input() departureIataCode: string;
  @Input() departureCity: string;
  @Input() returnIataCode: string;
  @Input() returnCity: string;
  @Input() dateDeparture: string;
  @Input() cabinClass: string = 'Economy';

  listSuggestedForYous: any[] = [];
  baseUrl = environment.baseURL;
  responsiveOptions: any;
  slideshows: any[] = [];
  isLoading: boolean = true;
  isShow: boolean = false;
  isShowNextButton = false;
  isInitial: boolean = false;
  airlineList: any[] = [];
  defaultImage = 'assets/images/background/cross-sale-default.png';
  private searchSubscription: Subscription | null = null;

  constructor(
    private searchFlightControllerService: SearchFlightControllerService,
    private translateService: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getSuggestedForYou();
    this.initData();
    this.airlineList = this.listSuggestedForYous.map((item) => item.t2);
    this.responsiveOptions = [
      {
        breakpoint: '1200',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '798px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '486px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
    this.isInitial = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (
    //   this.isInitial &&
    //   changes['country'] &&
    //   changes['country'].currentValue
    // ) {
    //   this.getSuggestedForYou();
    // }
  }

  getSuggestedForYou() {}

  cardClickHandle(airlines: string): void {
    const departDate = moment(this.dateDeparture)
      .clone()
      .add(1, 'day')
      .format('YYYY-MM-DD');
    const urlNavigate = `/booking/flight/search?optionTrip=false&departure=${this.departureIataCode}&departure_city=${this.departureCity}&departDate=${departDate}&arrived=${this.returnIataCode}&arrived_city=${this.returnCity}&sorting=LOWEST_PRICE&adults=${this.numOfAdults}&children=${this.numOfChildren}&infant=${this.numOfInfants}&class=${this.cabinClass}&airlines=${airlines}`;

    if (urlNavigate)
      window.open(`${environment.FLIGHT_URL}${urlNavigate}`, '_blank');
  }

  getDescriptionFlight(descript: string):
    | {
        airline_image: string;
        info: { airline_name: string; cabin_class: string };
      }
    | undefined {
    let description = undefined;

    try {
      const descriptionObject = JSON.parse(descript);
      if (descriptionObject) {
        const info = String(descriptionObject.info).split('|');
        description = {
          airline_image: descriptionObject.airline_image,
          info: {
            airline_name: info[0] ?? '',
            cabin_class: info[1] ?? '',
          },
        };
      }
    } catch (error) {
      description = undefined;
    }

    return description;
  }
  getDefaultImage(event: any): void {
    event.target.src = 'assets/images/background/cross-sale-default.png';
  }

  replaceWithDefaultImage(event: any): void {
    event.target.src = 'assets/images/user-management/default-image.jpg';
  }

  getImagePath(imageId: string, option: 'web' | 'thumbnail' = 'web'): string {
    if (imageId.toLowerCase().includes('http')) {
      return imageId;
    } else {
      if (imageId) {
        if (imageId.includes('.')) {
          return `${environment.baseURL}/storage/files/${option}/${imageId}`;
        } else {
          return `${environment.baseURL}/storage/files/${option}/${imageId}.webp`;
        }
      } else {
        return '';
      }
    }
  }
  initData() {
    let departDate = moment(this.dateDeparture)
      .clone()
      .add(1, 'day')
      .format('YYYY-MM-DD');
    let returnDate = moment(this.dateDeparture)
      .clone()
      .add(2, 'day')
      .format('YYYY-MM-DD');

    this.searchSubscription = this.searchFlightControllerService
      .getFlightByCriteria(
        this.departureIataCode,
        this.returnIataCode,
        departDate,
        this.numOfAdults,
        this.numOfChildren,
        this.numOfInfants,
        'USD',
        'LOWEST_PRICE',
        1,
        12,
        returnDate,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        this.cabinClass,
        undefined,
        undefined,
        true
      )
      .pipe(
        retry(2),
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(() => of<any[]>([]))
      )
      .subscribe((flights: any) => {
        if (!flights?.data?.flights?.length) {
          return;
        }
        this.airlineList = flights?.data?.flights;
      });
  }
}
